import React, { useState } from 'react';  // Remove useEffect
import { Container, Form, Button, Card } from 'react-bootstrap';
import contactService from '../services/contactService';

const ContactSettingsPage = () => {
  const [contactInfo, setContactInfo] = useState({
    address: {
      street: '123 Museum Street',
      city: 'Vilnius, Lithuania'
    },
    phone: '+370 123 45678',
    email: 'info@virtualmuseum.com',
    hours: {
      weekday: '9:00 - 18:00',
      weekend: '10:00 - 16:00'
    }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await contactService.updateContactInfo(contactInfo);
      alert('Contact information updated successfully!');
    } catch (error) {
      alert('Failed to update contact information');
    }
  };

  return (
    <Container className="py-4">
      <h2 className="mb-4">Contact Information Settings</h2>
      <Card>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <h5 className="mb-3">Address</h5>
            <Form.Group className="mb-3">
              <Form.Label>Street Address</Form.Label>
              <Form.Control
                type="text"
                value={contactInfo.address.street}
                onChange={(e) => setContactInfo({
                  ...contactInfo,
                  address: { ...contactInfo.address, street: e.target.value }
                })}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>City and Country</Form.Label>
              <Form.Control
                type="text"
                value={contactInfo.address.city}
                onChange={(e) => setContactInfo({
                  ...contactInfo,
                  address: { ...contactInfo.address, city: e.target.value }
                })}
              />
            </Form.Group>

            <h5 className="mb-3">Contact Details</h5>
            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                value={contactInfo.phone}
                onChange={(e) => setContactInfo({
                  ...contactInfo,
                  phone: e.target.value
                })}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                value={contactInfo.email}
                onChange={(e) => setContactInfo({
                  ...contactInfo,
                  email: e.target.value
                })}
              />
            </Form.Group>

            <h5 className="mb-3">Opening Hours</h5>
            <Form.Group className="mb-3">
              <Form.Label>Monday - Friday</Form.Label>
              <Form.Control
                type="text"
                value={contactInfo.hours.weekday}
                onChange={(e) => setContactInfo({
                  ...contactInfo,
                  hours: { ...contactInfo.hours, weekday: e.target.value }
                })}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Saturday - Sunday</Form.Label>
              <Form.Control
                type="text"
                value={contactInfo.hours.weekend}
                onChange={(e) => setContactInfo({
                  ...contactInfo,
                  hours: { ...contactInfo.hours, weekend: e.target.value }
                })}
              />
            </Form.Group>

            <Button type="submit" variant="primary">
              Save Changes
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ContactSettingsPage;